export default __webpack_public_path__ + "static/media/man.7a79addb.svg";